import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from "@angular/core";
import { VoicemailService } from "../../../../../../../common/services/api/resources/voicemail/voicemail.service";
import { AdvVoicemailboxWithExt } from "../../../admin-voicemail-types";

@Component({
  selector: "onsip-admin-voicemail-greeting-view",
  templateUrl: "./admin-voicemail-greeting-view.component.html",
  styleUrls: ["./admin-voicemail-greeting-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminVoicemailGreetingViewComponent implements OnChanges {
  @Input() voicemail!: AdvVoicemailboxWithExt;
  @Output() editPanel = new EventEmitter<void>();

  audioUrl: string | undefined;

  constructor(private voicemailService: VoicemailService) {}

  ngOnChanges() {
    if (this.voicemail.voicemail.greetings) {
      const unavailableGreeting = Object.keys(this.voicemail.voicemail.greetings).find(
        greeting => greeting === "UnavailableGreeting"
      );
      if (unavailableGreeting) {
        const audioUrl = this.voicemailService.getVoicemailUrl(
          this.voicemail.advVoicemailboxId,
          unavailableGreeting
        );
        if (audioUrl) {
          this.audioUrl = audioUrl;
        }
      }
    }
  }

  togglePanel() {
    this.editPanel.emit();
  }
}
